import React from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function SystemOverview() {
  const tomos = [{
    icon: '🟢',
    title: 'Tomo 1 — INFORMES TÉCNICOS Y OBRAS SOCIALES',
    desc: 'Estructura base de informes profesionales · Frases técnicas listas para copiar · Fundamentación clínica · Redacción para CUD, seguimiento y evolución · Modelos de cierre · Ejemplos por perfil · Plantillas de renovación de autorización. Todos los perfiles clínicos'
  }, {
    icon: '🟡',
    title: 'Tomo 2 — PLANIFICACIÓN DE SESIONES LISTA PARA USAR',
    desc: 'Planificación semanal, mensual y por objetivos · Sesiones tipo según edad y necesidad · Objetivos terapéuticos redactados · Secuencias de intervención · Registro de avances · Formato editable y reutilizable · Protocolo de evaluación inicial. Niños 2 a 12 años · Adultos'
  }, {
    icon: '🟠',
    title: 'Tomo 3 — INTEGRACIÓN SENSORIAL: 100 ACTIVIDADES',
    desc: 'Evaluación del perfil sensorial · 100 actividades por sistema y objetivo · Protocolos por perfil hiper e hiposensible · Dieta sensorial lista · Fichas de seguimiento · Actividades con materiales caseros · Criterios de progresión. Niños 2 a 12 años'
  }, {
    icon: '🔴',
    title: 'Tomo 4 — AUTONOMÍA Y ACTIVIDADES DE LA VIDA DIARIA',
    desc: 'Evaluación funcional con Escala FIM · Protocolos de vestido, alimentación e higiene · Secuencias visuales imprimibles · Entrenamiento de cuidadores · Adaptaciones low-cost · Gradación de la asistencia · Criterios de logro por nivel. Niños, adolescentes y adultos'
  }, {
    icon: '🟣',
    title: 'Tomo 5 — INCLUSIÓN ESCOLAR Y PROYECTO PEDAGÓGICO INDIVIDUAL',
    desc: 'Marco legal 2026 · Protocolo de observación en el aula · Plantilla completa de PPI · Matrices de adecuaciones por diagnóstico · Informes para docentes y EOE · Comunicación con familias y directivos · Guía de derechos educativos. Sistema educativo argentino'
  }, {
    icon: '⭐',
    title: 'Tomo 6 — EQUIPAMIENTO, ADAPTACIONES Y RECURSERO LOW-COST',
    desc: 'Catálogo de materiales con alternativas económicas · 7 guías de fabricación casera · Juguetes comerciales con potencial terapéutico · Directorio de proveedores nacionales · Marco legal de ayudas técnicas · Gestión ante la OS · Resumen de leyes de discapacidad. Argentina 2026'
  }];
  const includes = ['Planificación mensual y trimestral lista para usar', '30-50 actividades clínicas con objetivo, consigna y registro', 'Protocolos de evaluación con fichas de seguimiento', 'Plantillas de informe listas para completar', 'Materiales imprimibles para consolidar en sesión', '100% adaptado al Terapista Ocupacional argentino'];
  return <section className="py-16 px-4 pt-[15px] pb-[15px]" data-id="element-259">
      <div className="max-w-6xl mx-auto" data-id="element-260">
        <div className="text-center mb-12" data-id="element-261">
          <div className="inline-flex items-center space-x-2 bg-brand/10 text-brand px-4 py-2 rounded-full mb-6 font-bold" data-id="element-262">
            <Book className="w-5 h-5" data-id="element-263" />
            <span data-id="element-264">EL SISTEMA</span>
          </div>
          <h2 className="md:text-5xl font-black mb-4 text-[28px]" data-id="element-265">
            ULTRAPACK TERAPIA OCUPACIONAL LISTA™
          </h2>
          <p className="text-xl text-gray-400" data-id="element-266">
            6 Tomos + 6 Bonos — Todas las áreas — Todo resuelto
          </p>
          <p className="text-brand font-bold mt-2" data-id="element-267">
            +500 páginas · 200+ actividades clínicas listas · Evaluaciones ·
            Informes · Protocolos · Derivaciones · Tareas · Gestión · Marketing
            · Negocio.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-268">
          {['Informes y OS', 'Planificación', 'Integración Sensorial', 'AVD', 'Inclusión Escolar', 'Equipamiento'].map((tag, i) => <div key={i} className="bg-dark-card border border-dark-border px-2.5 py-1 rounded-full text-xs text-gray-300 font-medium" data-id="element-269">
              {tag}
            </div>)}
        </div>

        <h3 className="text-2xl font-bold mb-6 text-center mt-[-30px]" data-id="element-270">
          🎙️ LOS 6 TOMOS — Para Terapistas Ocupacionales de todas las áreas
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-271">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-4 hover:border-brand/50 transition-colors" data-id="element-272">
              <div className="text-2xl mb-3" data-id="element-273">{tomo.icon}</div>
              <h4 className="text-lg font-bold mb-2" data-id="element-274">{tomo.title}</h4>
              <p className="text-gray-400 text-sm" data-id="element-275">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-8 max-w-3xl mx-auto mt-[-25px] pt-[15px] pb-[15px] pl-[15px] pr-[15px] space-x-[12px] space-y-[16px]" data-id="element-276">
          <h4 className="text-xl font-bold mb-6 text-center" data-id="element-277">
            Cada tomo incluye:
          </h4>
          <div className="space-y-4" data-id="element-278">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center space-x-3" data-id="element-279">
                <CheckCircle2 className="w-6 h-6 text-brand flex-shrink-0" data-id="element-280" />
                <span className="text-gray-300 text-[16px]" data-id="element-281">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}